module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "5decreasing-bar.f0fb167e.svg";